import { Paper, Box, useTheme } from "@mui/material";
import { PlaceSuggestion } from "@/hooks";

type Props = {
  suggestions: PlaceSuggestion[];
  onSelect: (place: PlaceSuggestion) => void;
};

export const AutocompleteDropdown = ({ suggestions, onSelect }: Props) => {
  const theme = useTheme()
  const isDark = theme.palette.mode === "dark";

  if (!suggestions.length) return null;

  return (
    <Paper
      sx={{
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        mt: 1,
        zIndex: 10,
        maxHeight: 250,
        overflowY: "auto",
        backgroundColor: isDark ? "rgba(30,30,30,0.95)" : 'white',
        backdropFilter: "blur(12px)",
        borderRadius: 2,
      }}
    >
      {suggestions.map((p) => (
        <Box
          key={p.placeId}
          onClick={() => onSelect(p)}
          sx={{
            px: 2,
            py: 1.5,
            cursor: "pointer",
            "&:hover": {
              backgroundColor: isDark ? "rgba(255,255,255,0.1)" : "rgba(32, 127, 252, 0.1)",
            },
          }}
        >
          {p.description}
        </Box>
      ))}
    </Paper>
  );
};